import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BarChart3, ChevronDown, ChevronUp } from "lucide-react";

const http = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

const Bars = ({ title, items, testid }) => {
  const max = Math.max(...items.map((i) => i.count), 1);
  return (
    <div className="bg-ink p-5 md:p-6" data-testid={testid}>
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ochre mb-4">{title}</p>
      {items.length === 0 ? (
        <p className="text-sm text-stone2">No data yet.</p>
      ) : (
        <div className="space-y-2.5">
          {items.map((it) => (
            <div key={it.label}>
              <div className="flex items-baseline justify-between gap-3 mb-1">
                <span className="text-xs text-stone2 truncate">{it.label}</span>
                <span className="font-mono text-xs text-ember">{it.count}</span>
              </div>
              <div className="h-2 bg-surface2">
                <div className="h-2 bg-ember transition-all duration-500" style={{ width: `${(it.count / max) * 100}%` }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default function BriefingAnalytics() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    http.get("/briefing-requests/analytics")
      .then(({ data }) => setData(data))
      .catch(() => toast.error("Could not load briefing analytics."));
  }, []);

  if (!data) return null;

  return (
    <div className="border border-line bg-surface1 mb-8" data-testid="briefing-analytics">
      <button onClick={() => setOpen(!open)} data-testid="analytics-toggle" className="w-full flex items-center justify-between px-5 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-ember hover:text-emberDeep transition-colors duration-300">
        <span className="flex items-center gap-2"><BarChart3 size={14} /> Briefing analytics — {data.total} total requests</span>
        {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
      </button>
      {open && (
        <div className="grid md:grid-cols-3 gap-px bg-line/40 border-t border-line/40">
          <Bars title="By month" items={data.by_month} testid="chart-by-month" />
          <Bars title="By engagement type" items={data.by_engagement_type} testid="chart-by-type" />
          <Bars title="By budget range" items={data.by_budget_range} testid="chart-by-budget" />
        </div>
      )}
    </div>
  );
}
